import type { AreaDefinition } from '@/world/area';

/**
 * The coast, south-east of the farm.
 *
 * Exists so the four bodies of water are all reachable and visibly different:
 * a lake in the north, the river draining out of it, and the open sea along
 * the south. Each holds its own species, so where you cast matters as much as
 * when.
 *
 * Legend: . grass  , dark grass  = path  T tree  o rock
 *         L lake  r river  O ocean  s sand  S wet sand
 */
export const COAST_AREA: AreaDefinition = {
  id: 'coast',
  name: 'Saltmarch Coast',
  rows: [
    'TTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTT',
    'T.............................=............T',
    'T.............................=............T',
    'T...LLLLLLLLLLL.....,,,,......=............T',
    'T...LLLLLLLLLLL.....,,,,......=............T',
    'T..LLLLLLLLLLLLL..............=.......o....T',
    'T..LLLLLLLLLLLLL....T.........=............T',
    'T..LLLLLLLLLLLLL..............=............T',
    'T..LLLLLLLLLLLLL..............=.....T......T',
    'T...LLLLLLLLLLL...............=............T',
    'T...LLLLLLLLLLL.......o.......=............T',
    'T........rrrr.................=............T',
    'T........rrrr.................=............T',
    'T........rrrr.................=............T',
    'T........rrrr............T....=............T',
    'T........rrrr.................=..o....>....T',
    'T........rrrr.................=............T',
    'T........rrrr.................=............T',
    'T........rrrr.....T...........=............T',
    'T........rrrr.................=...T........T',
    'T........rrrr.................=....,,,,....T',
    'T........rrrrr...o............=....,,,,....T',
    'T.........rrrr................=............T',
    'T.........rrr==================............T',
    'Tssssssssssrrsssssssssssssssss=ssssssssssssT',
    'TssssssssssrrssssssssssssssssssssssssssssssT',
    'TSSSSSSSSSSrrSSSSSSSSSSSSSSSSSSSSSSSSSSSSSST',
    'TOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOT',
    'TOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOT',
    'TOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOT',
    'TOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOT',
    'TOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOT',
  ],
  spawn: { x: 30 * 16, y: 2 * 16 },
  portals: [{ x: 30, y: 1, toArea: 'farm', toX: 38, toY: 14 }],
};
